export default "__VITE_ASSET__BX7og1dR__"